import PropTypes from "prop-types";

import {
  objectTypes,
  actionNames,
  useTracker,
  eventTypes,
} from "@newsela/snitch";
import { transcriptRootCss } from "./VideoTranscript.style";

const propTypes = {
  contentId: PropTypes.string,
};

const VideoTranscript = ({ contentId }) => {
  const { trackAction, getEventName } = useTracker();

  return (
    <div
      css={transcriptRootCss}
      id="player_transcript"
      onClick={(event) => {
        const transcript = event.target.closest(".row-text")?.innerText;
        if (transcript) {
          const eventData = {
            event_name: getEventName(
              objectTypes.transcript,
              null,
              actionNames.navigate,
            ),
            event_type: eventTypes.click,
            dimension_properties: {
              content_id: contentId,
              content_type: "interactivevideolink",
              transcript_text_clicked: transcript,
            },
          };
          trackAction(eventData);
        }
      }}
    />
  );
};

VideoTranscript.propTypes = propTypes;

export default VideoTranscript;
